import { type PeopleListingQuery } from 'cms/cms';
// import HTMLReactParser from 'html-react-parser';
import { resolveImageReferenceToImage } from './imageResolver';
import type { ContentModelReference } from 'cms/cms-types';
import { type PeopleCardProps } from '3-components/Cards/CardPerson/CardPerson';

export type PersonPageResult = NonNullable<PeopleListingQuery['PersonPage']>;
export type PersonPageItems = NonNullable<PersonPageResult['items']>;
export interface PeopleCardResolverSettings {
    ctaLabel: string;
}

export const resolvePersonPagesToPeopleCards = (items: PersonPageItems, settings: PeopleCardResolverSettings): PeopleCardProps[] => {
    return items.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const { Name, PreviewTitle, ContentLink, PreviewImage, Role } = item as NonNullable<typeof item>;
        const imgSrcSets = [480, 767];
        const img = resolveImageReferenceToImage(PreviewImage as ContentModelReference, '?width=460', imgSrcSets);
        const label = settings?.ctaLabel ? settings.ctaLabel : '';

        return {
            ...(ContentLink?.Url && { link: { href: ContentLink.Url, label } }),
            title: PreviewTitle || Name || '',
            subtitle: Role || '',
            // ...(PreviewDescription && { children: HTMLReactParser(PreviewDescription as string) }),
            ...(img && { img }),
        };
    });
};
